/**
Project: Voice Panel (c)
Title: Subscriber Actions 
Description: Subscriber actions for handling subscriber details and the menu data.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import axios from "axios";
import { AppConfigProps } from "../../../../core/settings/app-config";
import {
  logMessage,
  checkIdentitySession,
  getSessionExpiredError,
} from "../../../../core/actions/common-actions";
import TokenUtil from "../../../../core/helpers/token-util";
import {
  SUBSCRIBER_IDENTITY,
  SUBSCRIBER_ACCOUNT,
  SUBSCRIBER_MENUS,
} from "../../../../store/voice-admin/constants";
import AppRoutes from "../../../routes/app-routes";
import { checkNumberUserPrivileges } from "../actions/general-actions";
const actionFileName = "subscriber-actions.js";

// Set Subscriber Identity to store
export function setSubscriberIdentity() {
  return async function (dispatch) {
    try {
      const identityTokenData =
        await TokenUtil.getIdentitySippioAccessTokenData();
      dispatch({
        type: SUBSCRIBER_IDENTITY,
        payload: identityTokenData,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

// Set Subscriber Account to store
export function setSubscriberAccount(cancelToken) {
  return async function (dispatch) {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await axios
        .get(
          AppConfigProps.serverRoutePrefix + "/subscriber-account",
          cancelToken
        )
        .then((res) => {
          if (
            res &&
            res.status === AppConfigProps.httpStatusCode.ok &&
            res.data &&
            res.data.result
          ) {
            dispatch({
              type: SUBSCRIBER_ACCOUNT,
              payload: {
                ...res.data.result,
                voiceNumbersPrivilege: checkNumberUserPrivileges(
                  res.data.result?.accountNumber
                ),
              },
              // payload: {
              //   accountNumber: "TAC40002-68102",
              //   voiceSetupStatus: true,
              //   voiceRerunSetupPrivilege: true,
              // },
            });
          } else {
            dispatch({
              type: SUBSCRIBER_ACCOUNT,
              payload: null,
            });
          }
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">setSubscriberAccount()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            throw err && err.response ? err.response : err;
          }
        });
    } else {
      throw getSessionExpiredError();
    }
  };
}

// Set Subscriber Voice Admin App Menu options
export function setSubscriberMenus(subscriberAccount) {
  return async function (dispatch) {
    try {
      let menuOptions = [];
      if (AppRoutes && AppRoutes.length > 0) {
        AppRoutes.forEach((route) => {
          if (subscriberAccount && subscriberAccount.accountNumber) {
            if (subscriberAccount.voiceNumbersPrivilege === true) {
              if (route.partCode === "STP-COM") {
                menuOptions.push(route);
              } else if (subscriberAccount.voiceSetupStatus === true) {
                menuOptions.push(route);
              }
            } else {
              if (route.partCode === "STP-COM") {
                menuOptions.push(route);
              } else if (subscriberAccount.voiceSetupStatus === true) {
                if (route.partCode === "NUM-COM") {
                  route.child = route?.child?.filter(
                    (rec) => rec.partCode !== "CFG-DPL"
                  );
                  menuOptions.push(route);
                } else {
                  menuOptions.push(route);
                }
              }
            }
          }
        });
      }
      dispatch({
        type: SUBSCRIBER_MENUS,
        payload: menuOptions,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}
